import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { AuthShell, AuthField } from "@/components/AuthShell";
import { useSafeMeAdminAuth, formatApiError } from "@/context/SafeMeAdminAuthContext";

function Brand() {
  return (
    <div className="flex items-center gap-2.5" data-testid="safeme-admin-brand">
      <ShieldCheck size={20} className="text-paper" strokeWidth={1.6} />
      <span className="font-display text-lg tracking-tight text-paper">
        BArecord <span className="text-fog">Admin</span>
      </span>
    </div>
  );
}

export default function SafeMeAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useSafeMeAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/barecord/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/barecord/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      brand={<Brand />}
      tagline="BArecord — owner oversight of every conversation."
      panelHeadline="Oversee. Govern. Secure."
      title="BArecord Admin"
      subtitle="Owner-only console to oversee all BArecord users, records and risk. Restricted access."
      image="https://static.prod-images.emergentagent.com/jobs/a7857c63-2010-4de3-a354-ef80fc69c639/images/29c5a35a6953ad6be50a2bfca7e8fe84874ff7ea36a30de0c488e32f298c2cca.png"
    >
      <form onSubmit={submit} className="space-y-4" data-testid="safeme-admin-login-form">
        <AuthField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required testid="safeme-admin-login-email" />
        <AuthField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required testid="safeme-admin-login-password" />
        {error && <p className="text-sm text-red-400" data-testid="safeme-admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="safeme-admin-login-submit"
          className="w-full rounded-full bg-paper text-black text-sm font-medium py-3.5 hover:bg-white transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Enter admin console"}
        </button>
      </form>
    </AuthShell>
  );
}
